const CONTENT_TYPE_COMMON_FIELDS = `
  name
  previewImage {
    filename
  }
  image {
    filename
  }
`;

const ARTISTS_FIELDS = `
  keepThisExactName
  artists(fields: ["name"]) {
    uuid
    full_slug: fullSlug
    content
  }
`;

const DETAILS_FIELDS = `
  startAt
  endAt
  location
`;

/**
 * @typedef {Object} ContentTypeFilter
 * @property {string} key
 * @property {string} searchParamName
 * @property {Function} queryBuilder
 */

/**
 * @typedef {Object} ContentType
 * @property {string} key
 * @property {string} component
 * @property {string} [fields]
 * @property {number} [limit]
 * @property {ContentTypeFilter} [filter]
 * @property {Object<string, number>} [limitFilteredBy]
 */

/**
 * @enum {ContentType}
 * @type {Object.<string, ContentType>}
 */
export const CONTENT_TYPE = {
  PAGE: {
    key: 'pages',
    component: 'page',
  },

  PRODUCT: {
    key: 'products',
    component: 'product',
  },

  RECIPE: {
    key: 'recipes',
    component: 'recipe',
    fields: `
      title
      time
      taste
      image {
        filename
        alt
      }
    `,
  },
};
